module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOCAYAAAAxDQxDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGpJREFUeNq81LENwCAMRFE4sYLnhXntIZJUEQoQTLDzm6us1zkyc1is1EtEqqP0AckddBo2kOwBPZEbE5FiBY2QJQybiBqDAaLCYIRMMRgirxiMkSEGB6SLwQlpsOSI1FiI11M9wg+dAgwApCA6TK7Pg+0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrow-up-popup.png
// module id = 133
// module chunks = 0